import { z } from 'zod';

const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

// Metadata only. The agent's prompt + first message are edited on the template
// editing page (the "New version" page), not here — this dialog never touches
// the ElevenLabs agent.
export const editInterviewTypeFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  slug: z
    .string()
    .min(1, 'Slug is required')
    .regex(SLUG_REGEX, 'Slug must be lowercase alphanumeric with single hyphens'),
  description: z.string(),
});

export type EditInterviewTypeFormValues = z.infer<typeof editInterviewTypeFormSchema>;
